export default __webpack_public_path__ + "static/earth_specular_2048-7c4c15698b5c37e69fc0a1ac928f01b0.jpg";